export const routes = {
  home: '/',
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  purchase: '/purchase',
  verifyAuth: '/auth/:token/business/:businessId',
  topupHistory: '/topup-history',
  chooseBusiness: '/choose-business',
  paymentManagement: '/payment-management',
  transactionStatus: '/transactionStatus',
  subscriptionTiers: '/subscription-tiers',
  instantPay: '/instant-pay',
  listBusiness: '/list-business',
  offers: '/offers',
  doubleUp: '/double-up',
  onboardingBusiness: '/onboarding-business',
  merchantPin: '/merchant-pin',
  businessDetails: '/business-details',
  invite: '/invite/:token',
  subscriptionHistory: '/subscription-history',
};
